module.exports = __webpack_public_path__ + "static/media/sf_300_gray.56e6c9dbb69e4504d54979d3b43f85fd.png";